import Swiper, {Pagination, Navigation, Autoplay} from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay]);

export namespace NewsSlider {
	let setupSlider = () => {

		let heroSliders = document.querySelectorAll('.js-news-slider');
		let threeUpSliders = document.querySelectorAll('.js-blog-3-column-slider');

		if ( heroSliders ) {
			//For Each Hero Slider Loop through and setup swiper
			heroSliders.forEach((slider, index) => {
				slider.classList.add(`news-slider--${index}`);
				const swiper = new Swiper(`.news-slider--${index}`, {
					loop: true,
					autoplay: {
						delay: 7000,
					},

					// If we need pagination
					pagination: {
						el: `.news-slider--${index} .swiper-pagination`,
						clickable: true
					},
				});
			});
		}

		if ( threeUpSliders ){
			//For Each Video Slider Loop through and setup swiper
			threeUpSliders.forEach((slider, index) => {

				slider.classList.add(`blog-3up__swiper--${index}`);
				const swiper = new Swiper(`.blog-3up__swiper--${index}`, {
					spaceBetween: 0,
					initialSlide: 0,
					breakpoints: {
						0: {
							slidesPerView: 1
						},
						768: {
							slidesPerView: 2,
							spaceBetween: 20
						},
						992: {
							slidesPerView: 3,
							spaceBetween: 20
						}
					},
					navigation: {
						nextEl: `.swiper-button-next`,
						prevEl: `.swiper-button-prev`,
					},
				});
			});
		}
	}

	export const init = () => {
		setupSlider();
	}
}

document.addEventListener('DOMContentLoaded', NewsSlider.init);
